(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ssk-build-your-setup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssk-setup')) {
    customElements.define('ssk-setup', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.pending = false;
        this.added = false;
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style:'currency', currency:this.dataset.currency || 'USD' });
        this.rows = Array.from(this.querySelectorAll('[data-setup-row]'));
        this.kayak = this.querySelector('[data-setup-kayak]');
        this.addButton = this.querySelector('[data-setup-add]');
        this.fields = this.querySelector('[data-setup-fields]');
        this.clearButton = this.querySelector('[data-setup-clear]');
        this.status = this.querySelector('[data-setup-status]');
        this.addEventListener('change', () => this.update());
        this.clearButton.addEventListener('click', () => {
          this.rows.forEach(row => { row.querySelector('[data-setup-check]').checked = false; });
          this.status.textContent = '';
          this.update();
        });
        this.addButton.addEventListener('click', () => this.addSetup());
        this.update();
      }
      format(cents) { return this.money.format(cents / 100); }
      selection() {
        const kayak = this.kayak.selectedOptions[0];
        let complete = Boolean(kayak && kayak.value && !kayak.disabled);
        let subtotal = 0;
        const items = new Map();
        if (complete) items.set(kayak.value, { id:kayak.value, quantity:1 });
        for (const row of this.rows) {
          const checked = row.querySelector('[data-setup-check]').checked;
          const option = row.querySelector('[data-setup-variant]').selectedOptions[0];
          const price = row.querySelector('[data-setup-price]');
          price.textContent = option && option.value ? this.format(Number(option.dataset.price)) : this.dataset.from + ' ' + this.format(Number(price.dataset.fromPrice));
          if (!checked) continue;
          if (!option || !option.value || option.disabled) { complete = false; continue; }
          if (!items.has(option.value)) {
            subtotal += Number(option.dataset.price);
            items.set(option.value, { id:option.value, quantity:1 });
          }
        }
        return { complete, subtotal, total:Number(kayak?.dataset.price || 0) + subtotal, items:Array.from(items.values()) };
      }
      update() {
        const state = this.selection();
        this.querySelector('[data-setup-subtotal]').textContent = state.complete ? this.format(state.subtotal) : this.dataset.choose;
        this.querySelector('[data-setup-total]').textContent = state.complete ? this.format(state.total) : this.dataset.choose;
        this.addButton.disabled = this.pending || this.added || !state.complete;
        this.clearButton.disabled = this.pending || this.added || !this.rows.some(row => row.querySelector('[data-setup-check]').checked);
      }
      async addSetup() {
        if (this.pending || this.added) return;
        const state = this.selection();
        if (!state.complete) return;
        this.pending = true;
        this.fields.disabled = true;
        this.addButton.textContent = this.dataset.adding;
        this.status.textContent = '';
        this.update();
        try {
          await new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', this.dataset.cartAddUrl);
            request.timeout = 20000;
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Accept', 'application/json');
            request.onload = () => {
              try {
                const result = JSON.parse(request.responseText);
                if (request.status < 200 || request.status >= 300) {
                  reject(new Error(typeof result.description === 'string' ? result.description : this.dataset.error));
                } else resolve(result);
              } catch { reject(new Error(this.dataset.error)); }
            };
            request.onerror = request.ontimeout = () => reject(new Error(this.dataset.error));
            request.send(JSON.stringify({ items:state.items }));
          });
          this.added = true;
          this.addButton.hidden = true;
          this.querySelector('[data-setup-view]').hidden = false;
          this.status.textContent = this.dataset.added;
        } catch (error) {
          this.status.textContent = error.message || this.dataset.error;
          this.querySelector('[data-setup-view]').hidden = false;
        } finally {
          this.pending = false;
          this.fields.disabled = this.added;
          this.addButton.textContent = this.dataset.add;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssk-custom-build"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssk-custom-build')) {
    customElements.define('ssk-custom-build', class extends HTMLElement {
      connectedCallback() {
        if (window.location.hash === '#ssk-custom-build') this.querySelector('details').open = true;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        document.addEventListener('click', event => {
          if (!event.target.closest('[data-ssk-custom-open]')) return;
          const details = this.querySelector('details');
          if (details) details.open = true;
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
